<template>
	<div>
		<h1 class="page-header"><i class="fa fa-wrench"></i> Fejlesztés alatt<small></small></h1>
		<div class="row">
			<NoRecords  main_icon="fa fa-wrench" value="false" title="Ez a menüpont fejlesztés alatt áll" subtitle="Térjen vissza később"></NoRecords>
		</div>
	</div>
</template>

<script>
	import NoRecords from '../components/NoRecords';
	export default {
		components:{
			NoRecords
		},
	};
</script>